// Produktsidan: på datorn ligger informationsmenyerna under produktbilden
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  let home = null;
  const place = () => {
    const tabs = document.querySelector('.product-info-tabs');
    const media = document.querySelector('.main-product .product__media-wrapper');
    if (!tabs || !media) return;
    if (!home) { home = document.createComment('nx-tabs'); tabs.parentNode.insertBefore(home, tabs); }
    if (mq.matches) { if (tabs.parentNode !== media) media.appendChild(tabs); }
    else if (tabs.previousSibling !== home) { home.parentNode.insertBefore(tabs, home.nextSibling); }
  };
  document.addEventListener('DOMContentLoaded', place);
  mq.addEventListener('change', place);
})();
